<template>
  <div>
    <el-collapse v-model="activeNames" class="collapse-main-content">
      <el-collapse-item name="1">
        <template slot="title">
          <div class="collapse-title-pre">
            <span></span>
            {{ $t('businessReceiptList.create.statusTitle') }}
          </div>
        </template>
        <div class="collapse-content">
          <status-form ref="statusForm" :defaultData="baseData" :userInfo="userInfo"></status-form>
        </div>
      </el-collapse-item>
      <el-collapse-item name="2">
        <template slot="title">
          <div class="collapse-title-pre">
            <span></span>
            {{ $t('businessReceiptList.create.baseTitle') }}
          </div>
        </template>
        <div class="collapse-content">
          <base-from ref="baseForm" :defaultData="baseData" :disabled="disabled"></base-from>
        </div>
      </el-collapse-item>
      <el-collapse-item name="4">
        <el-tabs type="border-card" v-model="activeNameTab" class="addCooperationTabs">
          <el-tab-pane name="first" :label="$t('businessReceiptList.create.productTitle')">
            <product-data
              v-if="showTable"
              :defaultData="defaultProduct"
              :inboundStatus="baseData.inboundStatus"
              :dataGroupHN="this.dataGroupHN"
              :isEdit="!disabled"
              ref="productTable"
              :exchangeRate="baseData.exchangeRate"
            ></product-data>
          </el-tab-pane>
          <el-tab-pane name="voucherTab" :label="$t('addInvoice.invoiceLine.title2')">
            <voucher
              ref="voucher"
              :voucherList="voucherList"
              @reverseInfo="reverseInfo"
              @postInfo="postInfo"
              @doConfirmInfo="doConfirmInfo"
            ></voucher>
          </el-tab-pane>
        </el-tabs>
      </el-collapse-item>

      <el-collapse-item name="5" v-if="attachmentList[0]">
        <!--上传附件-->
        <template slot="title">
          <div class="collapse-title-pre">
            <span></span>
            {{ $t('salesBill.title.uploadFile') }}
          </div>
        </template>
        <div class="collapse-content">
          <div>
            <upload ref="upload" :isShow="1 != 1" :tableData="attachmentList" />
          </div>
        </div>
      </el-collapse-item>
    </el-collapse>
    <div class="fixed-bottom-btnList">
      <!--TODO 根据不同状态展示不同按钮-->
      <el-button
        v-if="!disabled"
        v-hasPermi="['2021042915545982238']"
        @click="handleSave"
        type="primary"
        :loading="load"
        class="fixed-bottom-btn"
        :disabled="baseData.inboundStatus == '03' || baseData.inboundStatus == '05'"
        >{{ $t('functionBtn.save') }}</el-button
      >
      <el-button
        v-if="!disabled"
        v-hasPermi="['2021042915561936577']"
        @click="handleSubmit('Y')"
        type="primary"
        :loading="load"
        :disabled="baseData.inboundStatus == '03' || baseData.inboundStatus == '05'"
        class="fixed-bottom-btn"
        >{{ $t('functionBtn.commit') }}</el-button
      >
      <el-button
        @click="() => doWithdraw()"
        v-hasPermi="['2021042916023139528']"
        v-if="baseData.inboundStatus == '06'"
        type="primary"
        :loading="load"
        class="fixed-bottom-btn"
        >{{ $t('functionBtn.withdraw') }}</el-button
      >
      <el-button
        @click="doReverseAccountEntry"
        v-hasPermi="['2021042916031994604']"
        v-if="baseData.inboundStatus == '02'"
        type="warning"
        :loading="load"
        class="fixed-bottom-btn"
        >{{ $t('functionBtn.writeOff') }}</el-button
      >
      <el-button
        v-if="deleteButton"
        @click="() => handleDelete('04')"
        type="danger"
        :loading="load"
        class="fixed-bottom-btn"
        >{{ $t('functionBtn.delete') }}</el-button
      >
      <el-button
        v-if="baseData.inboundStatus == '02' || baseData.inboundStatus == '06'"
        @click="print"
        v-hasPermi="['2021071515480542360']"
        type="primary"
        :loading="load"
        class="fixed-bottom-btn"
        >{{ $t('functionBtn.print') }}</el-button
      >
      <el-button
        @click="handleAccountEntry"
        v-if="
          baseData.inboundStatus == '02' &&
          ['notgenerate', 'generated', 'postError'].indexOf(baseData.accountingStatus) != -1
        "
        type="primary"
        :loading="load"
        class="fixed-bottom-btn"
        >{{ this.$t('addInvoice.btns.accountEntry') }}</el-button
      >
      <el-button
        @click="doSyncVoucherForEntityData()"
        v-if="
          baseData.inboundStatus == '02' &&
          ['generated', 'postError'].indexOf(baseData.accountingStatus) != -1
        "
        type="primary"
        :loading="load"
        class="fixed-bottom-btn"
        >{{ this.$t('functionBtn.doSyncVoucher') }}</el-button
      >
      <!-- 确认按钮 -->
      <el-button
        @click="doConfirm"
        v-hasPermi="['2021042916025681640']"
        v-if="baseData.inboundStatus == '06'"
        type="primary"
        :loading="load"
        class="fixed-bottom-btn"
        >{{ $t('functionBtn.confirm') }}</el-button
      >
    </div>
    <print-dialog :dataGroupHN="dataGroupHN" ref="printDialog"></print-dialog>
  </div>
</template>

<script>
  import { mapState } from 'vuex';
  import statusForm from './components/statusForm';
  import baseFrom from './components/baseForm';
  // import financeForm from './components/financeForm';
  import productData from './components/productData';
  import API from '@/api/logisticsCenter/businessReceipt';
  // import { spliceMoreZero } from '@/common/js/util';
  import DataBaseAPI from '@/api/dataBase';
  import printDialog from './components/printDialog';
  // import { dateFormat } from '@/filters/index';
  import upload from '@/components/upload';
  import XEUtils from 'xe-utils';
  import voucherMixins from '@/common/mixins/voucher.js';
  export default {
    mixins: [voucherMixins],
    components: {
      statusForm,
      baseFrom,
      productData,
      printDialog,
      upload,
    },
    data() {
      return {
        attachmentList: [],
        dataGroupHN: false, //判断订单是否来自海宁
        showTable: true,
        activeNames: ['1', '2', '3', '4', '5'], // 默认展开那些面板
        load: false,
        baseData: {}, // 物流入库默认数据
        defaultProduct: [], // 商品行项目默认数据
        disabled: true,
        inboundQuantityList: {}, // 已经业务入库的数量
        inboundStatus: '',
        voucherFlag: 'AE_PO_MTL_ACCEPT', //凭证标识,
        //校验关联结算批次
        checkSettleParams: {
          associationType: 3,
          associationNoList: [],
        },
      };
    },
    computed: {
      ...mapState({
        userInfo: (state) => state.userInfo.userInfo,
        unitOptions() {
          return this.$baseRequest.getDictListByType('basic_unit');
        },
      }),
      deleteButton() {
        const deleteStatus = ['01'];
        return deleteStatus.indexOf(this.baseData.inboundStatus) > -1;
      },
    },
    mounted() {
      this.getData();
    },
    methods: {
      getData() {
        const query = this.$route.query;
        const name = this.$route.name;
        // 新增时获取供应商发货指令
        if (name == 'businessReceiptAdd') {
          // inboundQuantity: item.leftInboundQuantity
          this.showTable = false;
          this.disabled = false;
          const { shipNo } = query;
          const { inboundNoList } = query;
          if (shipNo) {
            const url = API.CREATE_INBOUND_BY_SHIP;
            if (inboundNoList) {
              //判断有没有物流号
              let urls = API.CREATE_INBOUND_BY_DISTRI;
              let params = {
                distributionInboundNos: inboundNoList.split(','),
                instructionNo: shipNo,
              };
              this.$axios.post(urls, params).then((res) => {
                if (res.data.code == 0) {
                  this.dataGroupHN = res.data.data.dataGroup == 'hn';
                  this.showTable = true;
                  this.baseData = res.data.data;
                  this.attachmentList = res.data.data.distributionAttachments || [];
                  this.$refs.statusForm.setData(this.baseData);
                  this.inboundStatus = this.baseData.inboundStatus;
                  this.defaultProduct = this.baseData.businessInboundDetailList || [];
                  this.defaultProduct.map((item) => {
                    return this.$baseRequest.assignObj(item);
                  });
                }
              });
            } else {
              this.$axios.post(url, { instructionNo: shipNo }).then((res) => {
                if (res.data.code == 0) {
                  this.dataGroupHN = res.data.data.dataGroup == 'hn';
                  this.showTable = true;
                  this.baseData = res.data.data;
                  this.$refs.statusForm.setData(this.baseData);
                  this.inboundStatus = this.baseData.inboundStatus;
                  this.defaultProduct = this.baseData.businessInboundDetailList || [];
                  this.defaultProduct.map((item) => {
                    return this.$baseRequest.assignObj(item);
                  });
                }
              });
            }
          }
        } else {
          // 编辑获取数据
          const { inboundNo } = query;
          if (inboundNo) {
            this.showTable = false;
            this.$axios
              .get(API.GET_BUSINESS_INBOUND, { inboundNo })
              .then((res) => {
                if (res.data.code == 0) {
                  this.dataGroupHN = res.data.data.dataGroup == 'hn';
                  this.attachmentList = res.data.data.distributionAttachments || [];
                  this.showTable = true;
                  const data = res.data.data;
                  // 业务入库状态: 已保存、已撤销 可编辑
                  const editStatus = ['01', '03'];
                  if (editStatus.indexOf(data.inboundStatus) > -1) {
                    this.disabled = false;
                  }
                  const baseData = Object.assign({}, data);
                  this.$refs.statusForm.setData(baseData);
                  delete baseData.businessInboundDetailList;
                  this.baseData = baseData;
                  this.defaultProduct = data.businessInboundDetailList;
                  // 获取凭证ID 获取凭证列表
                  this.entityDataId = this.baseData.id;
                  this.checkSettleParams.associationNoList = [this.baseData.inboundNo];
                  this.getAccountEntry();
                } else {
                  this.$message({
                    showClose: true,
                    message: res.data.msg,
                    type: 'error',
                  });
                }
              })
              .finally(() => {
                this.showTable = true;
                // if(this.baseData.inboundStatus=='0'||this.baseData.inboundStatus=='01'){
                //    if(!this.baseData.exchangeRate) this.getExchangeRate()
                //    this.$refs.productTable.updateTable()
                // }else{
                //     this.$refs.productTable.updateTable()
                // }
              });
          }
        }
      },
      //查汇率
      getExchangeRate() {
        if (this.baseData.currencyTypeCode == this.baseData.companyCurrencyCode) {
          this.baseData.exchangeRate = 1;
          return;
        }
        const params = {
          fromCurrencyCode: this.baseData.currencyTypeCode,
          toCurrencyCode: this.baseData.companyCurrencyCode,
        };
        this.$axios.post(DataBaseAPI.GET_CURRENCY_EXCHANGE, params).then((res) => {
          if (res.data.code === 0) {
            if (res.data.data) {
              this.baseData.exchangeRate = res.data.data.positiveRate;
            }
          } else {
            this.$alert(res.data.msg);
          }
        });
      },
      // 保存
      handleSave() {
        this.handlePost('01');
      },
      // 提交
      handleSubmit(submitCheck) {
        // this.getExchangeRate()
        const status = this.$refs.statusForm.handleSubmit();
        const base = this.$refs.baseForm.handleSubmit();
        // const finance = this.$refs.financeForm.handleSubmit();
        const product = this.$refs.productTable.handleSubmit();
        Promise.all([status, base, product]).then(() => {
          this.handlePost('06', submitCheck);
        });
      },
      // 保存、更新
      handlePost(inboundStatus, submitCheck, cancelValidate = false) {
        this.loading.startLoading();
        // 获取数据
        const statusData = this.$refs.statusForm.getValues();
        const baseData = this.$refs.baseForm.getValues();
        // const financeData = this.$refs.financeForm.getValues();
        let businessInboundDetail = this.$refs.productTable.getValues();
        if (!businessInboundDetail) return;
        let zeroInboundQuantity = true;
        businessInboundDetail.map((item) => {
          if (item.inboundQuantity == 0) {
            zeroInboundQuantity = false;
          }
        });
        if (!zeroInboundQuantity) {
          this.$message({
            showClose: true,
            message: this.$t('businessReceiptList.errorTips.zeroInboundQuantity'),
            type: 'error',
          });
          this.loading.endLoading();
          return;
        }
        let params = Object.assign({}, baseData, statusData, {
          businessInboundDetailList: businessInboundDetail,
          tenantCode: this.userInfo.tenantCode,
          contractNo: businessInboundDetail[0].contractNo,
          submitCheck: submitCheck,
          cancelValidate: cancelValidate,
        });
        let postUrl =
          inboundStatus == '06' ? API.SUBMIT_BUSINESS_INBOUND : API.SAVE_BUSINESS_INBOUND;
        this.$refs.productTable.updateTable();
        businessInboundDetail = this.$refs.productTable.getValues();
        params.businessInboundDetailList = XEUtils.clone(businessInboundDetail, true);
        params = this.$baseRequest.assignObj(params);
        this.postData(postUrl, params, inboundStatus);
      },
      // 确认
      doConfirmInfo(info) {
        this.loading.startLoading();
        this.postData(API.DO_CONFIRM, {
          id: this.baseData.id,
          inboundNo: this.baseData.inboundNo,
          ...info,
        });
      },
      postData(postUrl, params, type) {
        this.$axios
          .post(postUrl, params)
          .then((res) => {
            this.loading.endLoading();
            if (res.data.code == 0) {
              this.$message({
                showClose: true,
                message: res.data.msg,
                type: 'success',
              });
              // this.toList();
              if (type == '01') {
                if (this.$route.name == 'businessReceiptAdd') {
                  this.dblclickEvent(res.data.data);
                } else {
                  this.getData();
                }
              } else {
                this.toList();
              }
            } else if (res.data.code == 9) {
              // 提交时校验软提示
              this.$confirmAction('提示', res.data.msg)
                .then(() => {
                  this.handleSubmit('N');
                })
                .catch(() => {
                  if (this.$route.name == 'businessReceiptAdd') {
                    this.dblclickEvent(res.data.data);
                  }
                });
            } else if (res.data.code == 10) {
              this.$reportErrors({
                msg: res.data.msg,
                code: res.data.code,
                callback: () => {
                  //确认提交，cancelValidate传值true取消校验
                  this.handlePost('06', 'Y', true);
                },
              });
            } else {
              this.dblclickEvent(res.data.data);
              this.loading.endLoading();
              this.$message({
                showClose: true,
                message: res.data.msg,
                type: 'error',
                duration: 8000,
              });
            }
          })
          .catch(() => {
            this.loading.endLoading();
          });
      },
      //保存--修改
      dblclickEvent(value) {
        let path = {
          fromPath: {
            path: '/logistics/businessReceiptAdd',
            name: 'businessReceiptAdd',
            meta: {
              keepAlive: true,
              title: this.$t('businessReceiptList.create.tagTitle'),
            },
          },
          toPath: {
            path: '/logistics/businessReceiptEdit',
            name: 'businessReceiptEdit',
            meta: {
              keepAlive: true,
              title: '业务入库单编辑',
            },
            query:
              value.inboundNo && value.contractNo
                ? { inboundNo: value.inboundNo, contractNo: value.contractNo, sourceType: '2' }
                : {},
          },
        };
        this.$store.dispatch('tagsView/backTabView', path).then(() => {
          this.$nextTick(() => {
            this.$router.push(path.toPath);
          });
        });
      },
      // 删除
      handleDelete(status) {
        const title = status == '04' ? this.$t('confirm.delete') : this.$t('confirm.revert');
        const content =
          status == '04' ? this.$t('confirm.content') : this.$t('confirm.revertContent');
        this.$confirmAction(title, content)
          .then(() => {
            const { id, inboundNo, version } = this.baseData;
            const params = {
              id,
              inboundNo,
              inboundStatus: status,
              version,
            };
            this.$axios.post(API.DELETE_INBOUND, params).then((res) => {
              if (res.data.code == 0) {
                this.$message({
                  showClose: true,
                  message: res.data.msg,
                  type: 'success',
                });
                if (status == '04' || status == '03') {
                  this.toList();
                } else {
                  this.getData();
                }
              } else {
                this.$alert(res.data.msg);
              }
            });
          })
          .catch(() => {});
      },

      // 撤回
      async doWithdraw() {
        let params = {
          //撤回所需参数
          id: this.baseData.id,
          inboundNo: this.baseData.inboundNo,
          //检查关联结算批次所需参数
          ...this.checkSettleParams,
        };
        this.$baseRequest
          .doWithdrawCommon(API.DO_WITHDRAW, params)
          .then(() => {
            this.getData();
          })
          .catch((e) => {
            console.log(e);
          });
      },

      // 返回列表页
      toList() {
        const name = this.$route.name;
        let path = {
          fromPath: {
            path:
              name === 'businessReceiptAdd'
                ? '/logistics/businessReceiptAdd'
                : '/logistics/businessReceiptEdit',
            name: name === 'businessReceiptAdd' ? 'businessReceiptAdd' : 'businessReceiptEdit',
            meta: {
              keepAlive: true,
              title:
                name === 'businessReceiptAdd'
                  ? this.$t('businessReceiptList.create.tagTitle')
                  : this.$t('businessReceiptList.create.tagTitleEdit'),
            },
          },
          toPath: {
            path: '/logistics/businessReceiptList',
            name: 'businessReceiptList',
            meta: {
              keepAlive: false,
              title: this.$t('businessReceiptList.create.tagTitleSearch'),
            },
          },
        };
        this.$store.dispatch('tagsView/backTabView', path).then(() => {
          this.$nextTick(() => {
            this.$router.push(path.toPath);
          });
        });
      },
      // 打印
      print() {
        this.$refs.printDialog.openDialog(true, this.baseData.inboundNo);
      },
    },
  };
</script>
